import { HvacNotification } from 'common/models/Notifications';

export class RemoveNotifications {
    static readonly type = '[Notifications] RemoveNotifications';
    constructor(public readonly notifications: HvacNotification[]) { }
}
